import { defineMessages } from "react-intl";

export const messages = defineMessages({
  events: {
    id: "GLewww",
    defaultMessage: "Events",
    description: "section header",
  },
  synchronousEvents: {
    id: "dQdxLT",
    defaultMessage: "Synchronous events",
    description: "section subheader",
  },
  asynchronousEvents: {
    id: "TjbB4Y",
    defaultMessage: "Asynchronous events",
    description: "section subheader",
  },
  assignPermissionsToSynchronousEvents: {
    id: "fHopox",
    defaultMessage:
      "Assign permissions to register synchronous events for this webhook.",
    description: "section description",
  },
  assignPermissionsToAsynchronousEvents: {
    id: "QEvH8Q",
    defaultMessage:
      "Assign permissions to register asynchronous events for this webhook.",
    description: "section description",
  },
  registeredEvents: {
    id: "9Yhddc",
    defaultMessage: "Registered events",
    description: "input label",
  },
});
